// Onboarding translations for all 11 supported languages

export const onboardingTranslations = {
  pt: {
    step_account: "Conta",
    step_bank: "Banco",
    step_success: "Sucesso",
    account_title: "Cria a tua primeira empresa no MoneyLights",
    account_description: "Vamos configurar a conta da tua empresa. Esta será a base para todos os teus dados financeiros.",
    company_name: "Nome da empresa",
    company_name_required: "Nome da empresa *",
    company_name_placeholder: "Nome da tua empresa",
    first_name_required: "Primeiro nome *",
    first_name_placeholder: "O teu primeiro nome",
    last_name_required: "Último nome *",
    last_name_placeholder: "O teu último nome",
    country_currency: "País & Moeda *",
    select_country: "Seleciona o teu país",
    base_currency: "Moeda base",
    language: "Idioma",
    language_preselected: "Pré-selecionado com base nas configurações do teu browser",
    industry: "Sector",
    industry_optional: "(opcional)",
    select_industry: "Seleciona o teu sector",
    industry_help: "Isto ajuda-nos a fornecer melhores insights e benchmarks",
    save_error: "Nao foi possivel guardar os teus dados. Tenta novamente.",
    continue: "Continuar",
    need_help: "Precisas de ajuda?",
    contact_support: "Contactar suporte",
    bank_title: "Conecta o teu banco",
    bank_description: "Conecta a conta bancária de {{companyName}} através do Open Banking seguro para importar automaticamente as transações.",
    bank_security_title: "Segurança bancária",
    bank_security_description: "Utilizamos a plataforma Open Banking da Yapily. As tuas credenciais nunca são armazenadas e as ligações são apenas de leitura. Regulado pela UE e totalmente seguro.",
    bank_security_bullet_credentials: "As tuas credenciais nunca são armazenadas pelo MoneyLights",
    bank_security_bullet_readonly: "As ligações bancárias são apenas de leitura — nunca podemos movimentar fundos",
    bank_security_bullet_regulated: "Powered by Yapily, Open Banking regulado pela UE",
    connect_bank_account: "Conectar conta bancária",
    connecting: "A conectar...",
    supported_banks: "Bancos suportados em países da UE",
    more_banks: "+300 mais",
    bank_connected_title: "Banco conectado com sucesso",
    bank_connected_description: "A tua conta bancária está agora conectada. Estamos a iniciar a sincronização inicial.",
    back: "Voltar",
    skip_for_now: "Ignorar por agora",
    skip_help: "Podes conectar o teu banco mais tarde nas Definições",
    sync_limit_info: "O Open Banking permite até 4 sincronizações por dia. O MoneyLights agenda automaticamente as sincronizações para manter os teus dados atualizados sem atingir os limites. Não precisas de fazer nada — o MoneyLights gere as sincronizações automaticamente.",
    success_title_with_bank: "Está tudo pronto, {{companyName}}!",
    success_title_without_bank: "Conta criada, {{companyName}}!",
    success_description_with_bank: "A tua conta foi criada e o teu banco está conectado. Estamos a sincronizar as tuas transações em segundo plano.",
    success_description_without_bank: "A tua conta foi criada. Podes conectar o teu banco a qualquer momento nas Definições para começar a importar transações automaticamente.",
    success_bank_syncing: "A sincronizar o teu banco",
    success_bank_syncing_description: "As tuas transações estão a ser importadas em segundo plano",
    success_bank_not_connected: "Banco não conectado",
    success_connect_later: "Podes conectar mais tarde",
    next_steps: "Próximos passos",
    next_step_cashflow: "Ver para onde vai o teu dinheiro",
    next_step_cashflow_description: "Visualiza entradas, saídas e tendências do teu cash flow",
    next_step_categories: "Organizar transações por categorias",
    next_step_categories_description: "Cria categorias personalizadas para perceber melhor os teus gastos",
    cta_view_money: "Open MoneyLights",
    completing: "A finalizar...",
    success_help_tip: "Podes perguntar-me qualquer coisa sobre as tuas finanças — estou aqui para te ajudar a interpretar os teus números",
    create_account_flow: {
      title: "Criar nova conta",
      description: "Adiciona uma nova empresa ou contexto financeiro ao MoneyLights.",
      company_name_required: "Nome da empresa *",
      company_name_placeholder: "Nome da tua empresa",
      country_currency: "País & Moeda *",
      select_country: "Seleciona o teu país",
      base_currency: "Moeda base",
      industry: "Sector",
      industry_optional: "(opcional)",
      select_industry: "Seleciona o teu sector",
      cancel: "Cancelar",
      create_account: "Criar conta",
      success_title: "Conta criada com sucesso",
      success_description: "Queres ligar um banco agora ou preferes fazê-lo mais tarde?",
      connect_bank_now: "Ligar banco agora",
      connect_bank_later: "Fazer isto mais tarde",
      bank_title: "Conecta o teu banco",
      bank_description: "Conecta seguramente através do Open Banking para importar transações automaticamente.",
      bank_security_title: "Segurança bancária",
      bank_security_description: "As tuas credenciais nunca são armazenadas. Ligações apenas de leitura, reguladas pela UE.",
      connect_bank_account: "Conectar conta bancária",
      connecting: "A conectar...",
      skip_for_now: "Ignorar por agora",
      bank_connected_title: "Banco conectado com sucesso",
      bank_connected_description: "A tua conta bancária está agora conectada e a sincronizar.",
      finish: "Concluir"
    }
  },
  en: {
    step_account: "Account",
    step_bank: "Bank",
    step_success: "Success",
    account_title: "Create your first company on MoneyLights",
    account_description: "Let's set up your company account. This will be the foundation for all your financial data.",
    company_name: "Company name",
    company_name_required: "Company name *",
    company_name_placeholder: "Your company name",
    first_name_required: "First name *",
    first_name_placeholder: "Your first name",
    last_name_required: "Last name *",
    last_name_placeholder: "Your last name",
    country_currency: "Country & Currency *",
    select_country: "Select your country",
    base_currency: "Base currency",
    language: "Language",
    language_preselected: "Pre-selected based on your browser settings",
    industry: "Industry",
    industry_optional: "(optional)",
    select_industry: "Select your industry",
    industry_help: "This helps us provide better insights and benchmarks",
    save_error: "We couldn't save your details. Please try again.",
    continue: "Continue",
    need_help: "Need help?",
    contact_support: "Contact support",
    bank_title: "Connect your bank",
    bank_description: "Connect {{companyName}}'s bank account via secure Open Banking to automatically import transactions.",
    bank_security_title: "Bank-level security",
    bank_security_description: "We use Yapily's Open Banking platform. Your credentials are never stored, and connections are read-only. EU regulated and fully secure.",
    bank_security_bullet_credentials: "Your credentials are never stored by MoneyLights",
    bank_security_bullet_readonly: "Bank connections are read-only — we can never move funds",
    bank_security_bullet_regulated: "Powered by Yapily, EU-regulated Open Banking",
    connect_bank_account: "Connect bank account",
    connecting: "Connecting...",
    supported_banks: "Supported banks in EU countries",
    more_banks: "+300 more",
    bank_connected_title: "Bank connected successfully",
    bank_connected_description: "Your bank account is now connected. We're starting the initial sync.",
    back: "Back",
    skip_for_now: "Skip for now",
    skip_help: "You can connect your bank later in Settings",
    sync_limit_info: "Open Banking allows up to 4 syncs per day. MoneyLights automatically schedules syncs to keep your data fresh without hitting limits. You don't need to do anything — MoneyLights manages syncs automatically.",
    success_title_with_bank: "You're all set, {{companyName}}!",
    success_title_without_bank: "Account created, {{companyName}}!",
    success_description_with_bank: "Your account is created and your bank is connected. We're syncing your transactions in the background.",
    success_description_without_bank: "Your account is created. You can connect your bank anytime in Settings to start importing transactions automatically.",
    success_bank_syncing: "Syncing your bank",
    success_bank_syncing_description: "Your transactions are being imported in the background",
    success_bank_not_connected: "Bank not connected",
    success_connect_later: "You can connect later",
    next_steps: "Next steps",
    next_step_cashflow: "See where your money goes",
    next_step_cashflow_description: "Visualize income, expenses and cash flow trends",
    next_step_categories: "Organize transactions by categories",
    next_step_categories_description: "Create custom categories to better understand your spending",
    cta_view_money: "Open MoneyLights",
    completing: "Finishing...",
    success_help_tip: "You can ask me anything about your finances — I'm here to help you interpret your numbers",
    create_account_flow: {
      title: "Create new account",
      description: "Add a new company or financial context to MoneyLights.",
      company_name_required: "Company name *",
      company_name_placeholder: "Your company name",
      country_currency: "Country & Currency *",
      select_country: "Select your country",
      base_currency: "Base currency",
      industry: "Industry",
      industry_optional: "(optional)",
      select_industry: "Select your industry",
      cancel: "Cancel",
      create_account: "Create account",
      success_title: "Account created successfully",
      success_description: "Do you want to connect a bank now or would you prefer to do it later?",
      connect_bank_now: "Connect bank now",
      connect_bank_later: "Do this later",
      bank_title: "Connect your bank",
      bank_description: "Connect securely via Open Banking to automatically import transactions.",
      bank_security_title: "Bank-level security",
      bank_security_description: "Your credentials are never stored. Read-only connections, EU regulated.",
      connect_bank_account: "Connect bank account",
      connecting: "Connecting...",
      skip_for_now: "Skip for now",
      bank_connected_title: "Bank connected successfully",
      bank_connected_description: "Your bank account is now connected and syncing.",
      finish: "Finish"
    }
  },
  es: {
    step_account: "Cuenta",
    step_bank: "Banco",
    step_success: "Éxito",
    account_title: "Crea tu primera empresa en MoneyLights",
    account_description: "Configuremos la cuenta de tu empresa. Esta será la base de todos tus datos financieros.",
    company_name: "Nombre de la empresa",
    company_name_required: "Nombre de la empresa *",
    company_name_placeholder: "Nombre de tu empresa",
    country_currency: "País y Moneda *",
    select_country: "Selecciona tu país",
    base_currency: "Moneda base",
    language: "Idioma",
    language_preselected: "Preseleccionado según la configuración de tu navegador",
    industry: "Sector",
    industry_optional: "(opcional)",
    select_industry: "Selecciona tu sector",
    industry_help: "Esto nos ayuda a proporcionar mejores insights y benchmarks",
    continue: "Continuar",
    need_help: "¿Necesitas ayuda?",
    contact_support: "Contactar soporte",
    bank_title: "Conecta tu banco",
    bank_description: "Conecta la cuenta bancaria de {{companyName}} a través de Open Banking seguro para importar automáticamente las transacciones.",
    bank_security_title: "Seguridad bancaria",
    bank_security_description: "Utilizamos la plataforma Open Banking de Yapily. Tus credenciales nunca se almacenan y las conexiones son de solo lectura. Regulado por la UE y totalmente seguro.",
    bank_security_bullet_credentials: "Tus credenciales nunca son almacenadas por MoneyLights",
    bank_security_bullet_readonly: "Las conexiones bancarias son de solo lectura — nunca podemos mover fondos",
    bank_security_bullet_regulated: "Powered by Yapily, Open Banking regulado por la UE",
    connect_bank_account: "Conectar cuenta bancaria",
    connecting: "Conectando...",
    supported_banks: "Bancos compatibles en países de la UE",
    more_banks: "+300 más",
    bank_connected_title: "Banco conectado con éxito",
    bank_connected_description: "Tu cuenta bancaria está ahora conectada. Estamos iniciando la sincronización inicial.",
    back: "Atrás",
    skip_for_now: "Omitir por ahora",
    skip_help: "Puedes conectar tu banco más tarde en Configuración",
    sync_limit_info: "Open Banking permite hasta 4 sincronizaciones por día. MoneyLights programa automáticamente las sincronizaciones para mantener tus datos actualizados sin alcanzar los límites. No necesitas hacer nada — MoneyLights gestiona las sincronizaciones automáticamente.",
    success_title_with_bank: "¡Todo listo, {{companyName}}!",
    success_title_without_bank: "¡Cuenta creada, {{companyName}}!",
    success_description_with_bank: "Tu cuenta está creada y tu banco está conectado. Estamos sincronizando tus transacciones en segundo plano.",
    success_description_without_bank: "Tu cuenta está creada. Puedes conectar tu banco en cualquier momento en Configuración para comenzar a importar transacciones automáticamente.",
    success_bank_syncing: "Sincronizando tu banco",
    success_bank_syncing_description: "Tus transacciones se están importando en segundo plano",
    success_bank_not_connected: "Banco no conectado",
    success_connect_later: "Puedes conectar más tarde",
    next_steps: "Próximos pasos",
    next_step_cashflow: "Ver a dónde va tu dinero",
    next_step_cashflow_description: "Visualiza ingresos, gastos y tendencias de tu flujo de caja",
    next_step_categories: "Organizar transacciones por categorías",
    next_step_categories_description: "Crea categorías personalizadas para entender mejor tus gastos",
    cta_view_money: "Open MoneyLights",
    completing: "Finalizando...",
    success_help_tip: "Puedes preguntarme cualquier cosa sobre tus finanzas — estoy aquí para ayudarte a interpretar tus números",
    create_account_flow: {
      title: "Crear nueva cuenta",
      description: "Añade una nueva empresa o contexto financiero a MoneyLights.",
      company_name_required: "Nombre de la empresa *",
      company_name_placeholder: "Nombre de tu empresa",
      country_currency: "País y Moneda *",
      select_country: "Selecciona tu país",
      base_currency: "Moneda base",
      industry: "Sector",
      industry_optional: "(opcional)",
      select_industry: "Selecciona tu sector",
      cancel: "Cancelar",
      create_account: "Crear cuenta",
      success_title: "Cuenta creada con éxito",
      success_description: "¿Quieres conectar un banco ahora o prefieres hacerlo más tarde?",
      connect_bank_now: "Conectar banco ahora",
      connect_bank_later: "Hacer esto más tarde",
      bank_title: "Conecta tu banco",
      bank_description: "Conecta de forma segura a través de Open Banking para importar transacciones automáticamente.",
      bank_security_title: "Seguridad bancaria",
      bank_security_description: "Tus credenciales nunca se almacenan. Conexiones de solo lectura, reguladas por la UE.",
      connect_bank_account: "Conectar cuenta bancaria",
      connecting: "Conectando...",
      skip_for_now: "Omitir por ahora",
      bank_connected_title: "Banco conectado con éxito",
      bank_connected_description: "Tu cuenta bancaria está ahora conectada y sincronizando.",
      finish: "Finalizar"
    }
  },
  et: {
    step_account: "Konto",
    step_bank: "Pank",
    step_success: "Edu",
    account_title: "Loo oma esimene ettevõte MoneyLightsi",
    account_description: "Seadistame teie ettevõtte konto. See on kõigi teie finantsandmete alus.",
    company_name: "Ettevõtte nimi",
    company_name_required: "Ettevõtte nimi *",
    company_name_placeholder: "Teie ettevõtte nimi",
    country_currency: "Riik ja valuuta *",
    select_country: "Valige oma riik",
    base_currency: "Baasvaluuta",
    language: "Keel",
    language_preselected: "Eelvalitud brauseri seadete põhjal",
    industry: "Tööstus",
    industry_optional: "(valikuline)",
    select_industry: "Valige oma tööstus",
    industry_help: "See aitab meil pakkuda paremaid teadmisi ja võrdlusi",
    continue: "Jätka",
    need_help: "Vajate abi?",
    contact_support: "Võtke ühendust toega",
    bank_title: "Ühenda oma pank",
    bank_description: "Ühendage {{companyName}} pangakonto turvalise Open Bankingu kaudu, et tehinguid automaatselt importida.",
    bank_security_title: "Pangataseme turvalisus",
    bank_security_description: "Kasutame Yapily Open Bankingu platvormi. Teie mandaate ei salvestata kunagi ja ühendused on ainult lugemiseks. EL reguleeritud ja täiesti turvaline.",
    bank_security_bullet_credentials: "Teie mandaate ei salvestata kunagi MoneyLightsis",
    bank_security_bullet_readonly: "Pangaühendused on ainult lugemiseks — me ei saa kunagi raha liigutada",
    bank_security_bullet_regulated: "Powered by Yapily, EL reguleeritud Open Banking",
    connect_bank_account: "Ühenda pangakonto",
    connecting: "Ühendan...",
    supported_banks: "Toetatud pangad EL riikides",
    more_banks: "+300 veel",
    bank_connected_title: "Pank edukalt ühendatud",
    bank_connected_description: "Teie pangakonto on nüüd ühendatud. Alustame esialgset sünkroonimist.",
    back: "Tagasi",
    skip_for_now: "Jäta praegu vahele",
    skip_help: "Saate oma panga hiljem seadetes ühendada",
    sync_limit_info: "Open Banking lubab kuni 4 sünkroonimist päevas. MoneyLights planeerib sünkroonimised automaatselt, et hoida teie andmed värskena ilma piiranguid ületamata. Te ei pea midagi tegema — MoneyLights haldab sünkroonimisi automaatselt.",
    success_title_with_bank: "Olete valmis, {{companyName}}!",
    success_title_without_bank: "Konto loodud, {{companyName}}!",
    success_description_with_bank: "Teie konto on loodud ja pank on ühendatud. Sünkroonime teie tehinguid taustal.",
    success_description_without_bank: "Teie konto on loodud. Saate oma panga igal ajal seadetes ühendada, et alustada tehingute automaatset importimist.",
    success_bank_syncing: "Panga sünkroonimine",
    success_bank_syncing_description: "Teie tehinguid imporditakse taustal",
    success_bank_not_connected: "Pank pole ühendatud",
    success_connect_later: "Saate hiljem ühendada",
    next_steps: "Järgmised sammud",
    next_step_cashflow: "Vaadake, kuhu teie raha läheb",
    next_step_cashflow_description: "Visualiseerige sissetulekuid, kulusid ja rahavoo trende",
    next_step_categories: "Korraldage tehinguid kategooriate järgi",
    next_step_categories_description: "Looge kohandatud kategooriad, et paremini mõista oma kulutusi",
    cta_view_money: "Open MoneyLights",
    completing: "Lõpetamine...",
    success_help_tip: "Võite minult küsida mis tahes oma rahaasjade kohta — olen siin, et aidata teil oma numbreid tõlgendada",
    create_account_flow: {
      title: "Loo uus konto",
      description: "Lisa MoneyLightsile uus ettevõte või finantskontext.",
      company_name_required: "Ettevõtte nimi *",
      company_name_placeholder: "Teie ettevõtte nimi",
      country_currency: "Riik ja valuuta *",
      select_country: "Valige oma riik",
      base_currency: "Põhivaluuta",
      industry: "Tööstus",
      industry_optional: "(valikuline)",
      select_industry: "Valige oma tööstus",
      cancel: "Tühista",
      create_account: "Loo konto",
      success_title: "Konto edukalt loodud",
      success_description: "Kas soovite ühendada panga nüüd või eelistate seda hiljem teha?",
      connect_bank_now: "Ühenda pank nüüd",
      connect_bank_later: "Tee seda hiljem",
      bank_title: "Ühenda oma pank",
      bank_description: "Ühendage turvaliselt Open Bankingu kaudu, et tehinguid automaatselt importida.",
      bank_security_title: "Pangataseme turvalisus",
      bank_security_description: "Teie mandaate ei salvestata kunagi. Ainult lugemiseks ühendused, EL reguleeritud.",
      connect_bank_account: "Ühenda pangakonto",
      connecting: "Ühendan...",
      skip_for_now: "Jäta praegu vahele",
      bank_connected_title: "Pank edukalt ühendatud",
      bank_connected_description: "Teie pangakonto on nüüd ühendatud ja sünkroonitakse.",
      finish: "Lõpeta"
    }
  },
  de: {
    step_account: "Konto",
    step_bank: "Bank",
    step_success: "Erfolg",
    account_title: "Erstellen Sie Ihr erstes Unternehmen auf MoneyLights",
    account_description: "Richten wir Ihr Firmenkonto ein. Dies wird die Grundlage für alle Ihre Finanzdaten sein.",
    company_name: "Firmenname",
    company_name_required: "Firmenname *",
    company_name_placeholder: "Ihr Firmenname",
    country_currency: "Land & Währung *",
    select_country: "Wählen Sie Ihr Land",
    base_currency: "Basiswährung",
    language: "Sprache",
    language_preselected: "Vorausgewählt basierend auf Ihren Browser-Einstellungen",
    industry: "Branche",
    industry_optional: "(optional)",
    select_industry: "Wählen Sie Ihre Branche",
    industry_help: "Dies hilft uns, bessere Einblicke und Benchmarks bereitzustellen",
    continue: "Weiter",
    need_help: "Brauchen Sie Hilfe?",
    contact_support: "Support kontaktieren",
    bank_title: "Verbinden Sie Ihre Bank",
    bank_description: "Verbinden Sie das Bankkonto von {{companyName}} über sicheres Open Banking, um Transaktionen automatisch zu importieren.",
    bank_security_title: "Bank-Level-Sicherheit",
    bank_security_description: "Wir verwenden die Open Banking-Plattform von Yapily. Ihre Anmeldedaten werden niemals gespeichert und Verbindungen sind schreibgeschützt. EU-reguliert und vollständig sicher.",
    bank_security_bullet_credentials: "Ihre Anmeldedaten werden niemals von MoneyLights gespeichert",
    bank_security_bullet_readonly: "Bankverbindungen sind schreibgeschützt — wir können niemals Geld bewegen",
    bank_security_bullet_regulated: "Powered by Yapily, EU-reguliertes Open Banking",
    connect_bank_account: "Bankkonto verbinden",
    connecting: "Verbinde...",
    supported_banks: "Unterstützte Banken in EU-Ländern",
    more_banks: "+300 weitere",
    bank_connected_title: "Bank erfolgreich verbunden",
    bank_connected_description: "Ihr Bankkonto ist jetzt verbunden. Wir starten die erste Synchronisation.",
    back: "Zurück",
    skip_for_now: "Jetzt überspringen",
    skip_help: "Sie können Ihre Bank später in den Einstellungen verbinden",
    sync_limit_info: "Open Banking erlaubt bis zu 4 Synchronisationen pro Tag. MoneyLights plant Synchronisationen automatisch, um Ihre Daten aktuell zu halten, ohne Limits zu erreichen. Sie müssen nichts tun — MoneyLights verwaltet Synchronisationen automatisch.",
    success_title_with_bank: "Alles bereit, {{companyName}}!",
    success_title_without_bank: "Konto erstellt, {{companyName}}!",
    success_description_with_bank: "Ihr Konto ist erstellt und Ihre Bank ist verbunden. Wir synchronisieren Ihre Transaktionen im Hintergrund.",
    success_description_without_bank: "Ihr Konto ist erstellt. Sie können Ihre Bank jederzeit in den Einstellungen verbinden, um Transaktionen automatisch zu importieren.",
    success_bank_syncing: "Synchronisierung Ihrer Bank",
    success_bank_syncing_description: "Ihre Transaktionen werden im Hintergrund importiert",
    success_bank_not_connected: "Bank nicht verbunden",
    success_connect_later: "Sie können später verbinden",
    next_steps: "Nächste Schritte",
    next_step_cashflow: "Sehen Sie, wohin Ihr Geld fließt",
    next_step_cashflow_description: "Visualisieren Sie Einnahmen, Ausgaben und Cashflow-Trends",
    next_step_categories: "Transaktionen nach Kategorien organisieren",
    next_step_categories_description: "Erstellen Sie benutzerdefinierte Kategorien, um Ihre Ausgaben besser zu verstehen",
    cta_view_money: "Open MoneyLights",
    completing: "Wird abgeschlossen...",
    success_help_tip: "Sie können mich alles über Ihre Finanzen fragen — ich bin hier, um Ihnen bei der Interpretation Ihrer Zahlen zu helfen",
    create_account_flow: {
      title: "Neues Konto erstellen",
      description: "Fügen Sie eine neue Firma oder einen finanziellen Kontext zu MoneyLights hinzu.",
      company_name_required: "Firmenname *",
      company_name_placeholder: "Ihr Firmenname",
      country_currency: "Land & Währung *",
      select_country: "Wählen Sie Ihr Land",
      base_currency: "Basiswährung",
      industry: "Branche",
      industry_optional: "(optional)",
      select_industry: "Wählen Sie Ihre Branche",
      cancel: "Abbrechen",
      create_account: "Konto erstellen",
      success_title: "Konto erfolgreich erstellt",
      success_description: "Möchten Sie jetzt eine Bank verbinden oder möchten Sie dies später tun?",
      connect_bank_now: "Bank jetzt verbinden",
      connect_bank_later: "Dies später tun",
      bank_title: "Verbinden Sie Ihre Bank",
      bank_description: "Verbinden Sie sich sicher über Open Banking, um Transaktionen automatisch zu importieren.",
      bank_security_title: "Bank-Level-Sicherheit",
      bank_security_description: "Ihre Anmeldedaten werden niemals gespeichert. Nur-Lese-Verbindungen, EU-reguliert.",
      connect_bank_account: "Bankkonto verbinden",
      connecting: "Verbinden...",
      skip_for_now: "Für jetzt überspringen",
      bank_connected_title: "Bank erfolgreich verbunden",
      bank_connected_description: "Ihr Bankkonto ist jetzt verbunden und synchronisiert.",
      finish: "Fertig"
    }
  },
  fr: {
    step_account: "Compte",
    step_bank: "Banque",
    step_success: "Succès",
    account_title: "Créez votre première entreprise sur MoneyLights",
    account_description: "Configurons le compte de votre entreprise. Ce sera la base de toutes vos données financières.",
    company_name: "Nom de l'entreprise",
    company_name_required: "Nom de l'entreprise *",
    company_name_placeholder: "Nom de votre entreprise",
    country_currency: "Pays et Devise *",
    select_country: "Sélectionnez votre pays",
    base_currency: "Devise de base",
    language: "Langue",
    language_preselected: "Présélectionné selon les paramètres de votre navigateur",
    industry: "Secteur",
    industry_optional: "(facultatif)",
    select_industry: "Sélectionnez votre secteur",
    industry_help: "Cela nous aide à fournir de meilleurs insights et benchmarks",
    continue: "Continuer",
    need_help: "Besoin d'aide?",
    contact_support: "Contacter le support",
    bank_title: "Connectez votre banque",
    bank_description: "Connectez le compte bancaire de {{companyName}} via Open Banking sécurisé pour importer automatiquement les transactions.",
    bank_security_title: "Sécurité bancaire",
    bank_security_description: "Nous utilisons la plateforme Open Banking de Yapily. Vos identifiants ne sont jamais stockés et les connexions sont en lecture seule. Réglementé par l'UE et entièrement sécurisé.",
    bank_security_bullet_credentials: "Vos identifiants ne sont jamais stockés par MoneyLights",
    bank_security_bullet_readonly: "Les connexions bancaires sont en lecture seule — nous ne pouvons jamais déplacer de fonds",
    bank_security_bullet_regulated: "Powered by Yapily, Open Banking réglementé par l'UE",
    connect_bank_account: "Connecter le compte bancaire",
    connecting: "Connexion...",
    supported_banks: "Banques prises en charge dans les pays de l'UE",
    more_banks: "+300 de plus",
    bank_connected_title: "Banque connectée avec succès",
    bank_connected_description: "Votre compte bancaire est maintenant connecté. Nous démarrons la synchronisation initiale.",
    back: "Retour",
    skip_for_now: "Ignorer pour le moment",
    skip_help: "Vous pouvez connecter votre banque plus tard dans les Paramètres",
    sync_limit_info: "Open Banking autorise jusqu'à 4 synchronisations par jour. MoneyLights planifie automatiquement les synchronisations pour garder vos données à jour sans atteindre les limites. Vous n'avez rien à faire — MoneyLights gère les synchronisations automatiquement.",
    success_title_with_bank: "Tout est prêt, {{companyName}} !",
    success_title_without_bank: "Compte créé, {{companyName}} !",
    success_description_with_bank: "Votre compte est créé et votre banque est connectée. Nous synchronisons vos transactions en arrière-plan.",
    success_description_without_bank: "Votre compte est créé. Vous pouvez connecter votre banque à tout moment dans les Paramètres pour commencer à importer les transactions automatiquement.",
    success_bank_syncing: "Synchronisation de votre banque",
    success_bank_syncing_description: "Vos transactions sont importées en arrière-plan",
    success_bank_not_connected: "Banque non connectée",
    success_connect_later: "Vous pouvez connecter plus tard",
    next_steps: "Prochaines étapes",
    next_step_cashflow: "Voir où va votre argent",
    next_step_cashflow_description: "Visualisez les revenus, dépenses et tendances de trésorerie",
    next_step_categories: "Organiser les transactions par catégories",
    next_step_categories_description: "Créez des catégories personnalisées pour mieux comprendre vos dépenses",
    cta_view_money: "Open MoneyLights",
    completing: "Finalisation...",
    success_help_tip: "Vous pouvez me poser n'importe quelle question sur vos finances — je suis là pour vous aider à interpréter vos chiffres",
    create_account_flow: {
      title: "Créer nouveau compte",
      description: "Ajoutez une nouvelle entreprise ou un contexte financier à MoneyLights.",
      company_name_required: "Nom de l'entreprise *",
      company_name_placeholder: "Nom de votre entreprise",
      country_currency: "Pays et Devise *",
      select_country: "Sélectionnez votre pays",
      base_currency: "Devise de base",
      industry: "Secteur",
      industry_optional: "(optionnel)",
      select_industry: "Sélectionnez votre secteur",
      cancel: "Annuler",
      create_account: "Créer un compte",
      success_title: "Compte créé avec succès",
      success_description: "Voulez-vous connecter une banque maintenant ou préférez-vous le faire plus tard ?",
      connect_bank_now: "Connecter la banque maintenant",
      connect_bank_later: "Faire cela plus tard",
      bank_title: "Connectez votre banque",
      bank_description: "Connectez-vous en toute sécurité via Open Banking pour importer automatiquement les transactions.",
      bank_security_title: "Sécurité bancaire",
      bank_security_description: "Vos identifiants ne sont jamais stockés. Connexions en lecture seule, réglementées par l'UE.",
      connect_bank_account: "Connecter un compte bancaire",
      connecting: "Connexion...",
      skip_for_now: "Ignorer pour l'instant",
      bank_connected_title: "Banque connectée avec succès",
      bank_connected_description: "Votre compte bancaire est maintenant connecté et en cours de synchronisation.",
      finish: "Terminer"
    }
  },
  it: {
    step_account: "Account",
    step_bank: "Banca",
    step_success: "Successo",
    account_title: "Crea la tua prima azienda su MoneyLights",
    account_description: "Configuriamo l'account della tua azienda. Questa sarà la base per tutti i tuoi dati finanziari.",
    company_name: "Nome dell'azienda",
    company_name_required: "Nome dell'azienda *",
    company_name_placeholder: "Nome della tua azienda",
    country_currency: "Paese e Valuta *",
    select_country: "Seleziona il tuo paese",
    base_currency: "Valuta di base",
    language: "Lingua",
    language_preselected: "Preselezionato in base alle impostazioni del browser",
    industry: "Settore",
    industry_optional: "(facoltativo)",
    select_industry: "Seleziona il tuo settore",
    industry_help: "Questo ci aiuta a fornire migliori insights e benchmark",
    continue: "Continua",
    need_help: "Hai bisogno di aiuto?",
    contact_support: "Contatta il supporto",
    bank_title: "Connetti la tua banca",
    bank_description: "Connetti il conto bancario di {{companyName}} tramite Open Banking sicuro per importare automaticamente le transazioni.",
    bank_security_title: "Sicurezza bancaria",
    bank_security_description: "Utilizziamo la piattaforma Open Banking di Yapily. Le tue credenziali non vengono mai memorizzate e le connessioni sono di sola lettura. Regolamentato dall'UE e completamente sicuro.",
    bank_security_bullet_credentials: "Le tue credenziali non vengono mai memorizzate da MoneyLights",
    bank_security_bullet_readonly: "Le connessioni bancarie sono di sola lettura — non possiamo mai spostare fondi",
    bank_security_bullet_regulated: "Powered by Yapily, Open Banking regolamentato dall'UE",
    connect_bank_account: "Connetti conto bancario",
    connecting: "Connessione...",
    supported_banks: "Banche supportate nei paesi UE",
    more_banks: "+300 altre",
    bank_connected_title: "Banca connessa con successo",
    bank_connected_description: "Il tuo conto bancario è ora connesso. Stiamo avviando la sincronizzazione iniziale.",
    back: "Indietro",
    skip_for_now: "Salta per ora",
    skip_help: "Puoi connettere la tua banca più tardi nelle Impostazioni",
    sync_limit_info: "Open Banking consente fino a 4 sincronizzazioni al giorno. MoneyLights pianifica automaticamente le sincronizzazioni per mantenere i tuoi dati aggiornati senza raggiungere i limiti. Non devi fare nulla — MoneyLights gestisce le sincronizzazioni automaticamente.",
    success_title_with_bank: "Sei pronto, {{companyName}}!",
    success_title_without_bank: "Account creato, {{companyName}}!",
    success_description_with_bank: "Il tuo account è creato e la tua banca è connessa. Stiamo sincronizzando le tue transazioni in background.",
    success_description_without_bank: "Il tuo account è creato. Puoi connettere la tua banca in qualsiasi momento nelle Impostazioni per iniziare a importare le transazioni automaticamente.",
    success_bank_syncing: "Sincronizzazione della tua banca",
    success_bank_syncing_description: "Le tue transazioni vengono importate in background",
    success_bank_not_connected: "Banca non connessa",
    success_connect_later: "Puoi connettere più tardi",
    next_steps: "Prossimi passi",
    next_step_cashflow: "Vedi dove vanno i tuoi soldi",
    next_step_cashflow_description: "Visualizza entrate, uscite e tendenze del flusso di cassa",
    next_step_categories: "Organizza le transazioni per categorie",
    next_step_categories_description: "Crea categorie personalizzate per capire meglio le tue spese",
    cta_view_money: "Open MoneyLights",
    completing: "Completamento...",
    success_help_tip: "Puoi chiedermi qualsiasi cosa sulle tue finanze — sono qui per aiutarti a interpretare i tuoi numeri",
    create_account_flow: {
      title: "Crea nuovo account",
      description: "Aggiungi una nuova azienda o un contesto finanziario a MoneyLights.",
      company_name_required: "Nome dell'azienda *",
      company_name_placeholder: "Nome della tua azienda",
      country_currency: "Paese e Valuta *",
      select_country: "Seleziona il tuo paese",
      base_currency: "Valuta base",
      industry: "Settore",
      industry_optional: "(opzionale)",
      select_industry: "Seleziona il tuo settore",
      cancel: "Annulla",
      create_account: "Crea account",
      success_title: "Account creato con successo",
      success_description: "Vuoi collegare una banca ora o preferisci farlo più tardi?",
      connect_bank_now: "Collega banca ora",
      connect_bank_later: "Fallo più tardi",
      bank_title: "Collega la tua banca",
      bank_description: "Collegati in modo sicuro tramite Open Banking per importare automaticamente le transazioni.",
      bank_security_title: "Sicurezza bancaria",
      bank_security_description: "Le tue credenziali non vengono mai memorizzate. Connessioni di sola lettura, regolamentate dall'UE.",
      connect_bank_account: "Collega conto bancario",
      connecting: "Collegamento...",
      skip_for_now: "Salta per ora",
      bank_connected_title: "Banca collegata con successo",
      bank_connected_description: "Il tuo conto bancario è ora collegato e in sincronizzazione.",
      finish: "Termina"
    }
  },
  nl: {
    step_account: "Account",
    step_bank: "Bank",
    step_success: "Succes",
    account_title: "Maak uw eerste bedrijf aan op MoneyLights",
    account_description: "Laten we uw bedrijfsaccount instellen. Dit wordt de basis voor al uw financiële gegevens.",
    company_name: "Bedrijfsnaam",
    company_name_required: "Bedrijfsnaam *",
    company_name_placeholder: "Uw bedrijfsnaam",
    country_currency: "Land & Valuta *",
    select_country: "Selecteer uw land",
    base_currency: "Basisvaluta",
    language: "Taal",
    language_preselected: "Vooraf geselecteerd op basis van uw browserinstellingen",
    industry: "Sector",
    industry_optional: "(optioneel)",
    select_industry: "Selecteer uw sector",
    industry_help: "Dit helpt ons betere inzichten en benchmarks te bieden",
    continue: "Doorgaan",
    need_help: "Hulp nodig?",
    contact_support: "Neem contact op met ondersteuning",
    bank_title: "Verbind uw bank",
    bank_description: "Verbind de bankrekening van {{companyName}} via veilige Open Banking om transacties automatisch te importeren.",
    bank_security_title: "Beveiliging op bankniveau",
    bank_security_description: "We gebruiken het Open Banking-platform van Yapily. Uw inloggegevens worden nooit opgeslagen en verbindingen zijn alleen-lezen. EU-gereguleerd en volledig veilig.",
    bank_security_bullet_credentials: "Uw inloggegevens worden nooit opgeslagen door MoneyLights",
    bank_security_bullet_readonly: "Bankverbindingen zijn alleen-lezen — we kunnen nooit geld verplaatsen",
    bank_security_bullet_regulated: "Powered by Yapily, EU-gereguleerd Open Banking",
    connect_bank_account: "Bankrekening verbinden",
    connecting: "Verbinden...",
    supported_banks: "Ondersteunde banken in EU-landen",
    more_banks: "+300 meer",
    bank_connected_title: "Bank succesvol verbonden",
    bank_connected_description: "Uw bankrekening is nu verbonden. We starten de initiële synchronisatie.",
    back: "Terug",
    skip_for_now: "Nu overslaan",
    skip_help: "U kunt uw bank later verbinden in Instellingen",
    sync_limit_info: "Open Banking staat maximaal 4 synchronisaties per dag toe. MoneyLights plant synchronisaties automatisch om uw gegevens actueel te houden zonder limieten te bereiken. U hoeft niets te doen — MoneyLights beheert synchronisaties automatisch.",
    success_title_with_bank: "U bent helemaal klaar, {{companyName}}!",
    success_title_without_bank: "Account aangemaakt, {{companyName}}!",
    success_description_with_bank: "Uw account is aangemaakt en uw bank is verbonden. We synchroniseren uw transacties op de achtergrond.",
    success_description_without_bank: "Uw account is aangemaakt. U kunt uw bank op elk moment verbinden in Instellingen om transacties automatisch te importeren.",
    success_bank_syncing: "Uw bank synchroniseren",
    success_bank_syncing_description: "Uw transacties worden op de achtergrond geïmporteerd",
    success_bank_not_connected: "Bank niet verbonden",
    success_connect_later: "U kunt later verbinden",
    next_steps: "Volgende stappen",
    next_step_cashflow: "Zie waar uw geld naartoe gaat",
    next_step_cashflow_description: "Visualiseer inkomsten, uitgaven en cashflow-trends",
    next_step_categories: "Organiseer transacties per categorie",
    next_step_categories_description: "Maak aangepaste categorieën om uw uitgaven beter te begrijpen",
    cta_view_money: "Open MoneyLights",
    completing: "Bezig met afronden...",
    success_help_tip: "U kunt me alles vragen over uw financiën — ik ben hier om u te helpen uw cijfers te interpreteren",
    create_account_flow: {
      title: "Nieuw account aanmaken",
      description: "Voeg een nieuw bedrijf of financiële context toe aan MoneyLights.",
      company_name_required: "Bedrijfsnaam *",
      company_name_placeholder: "Uw bedrijfsnaam",
      country_currency: "Land & Valuta *",
      select_country: "Selecteer uw land",
      base_currency: "Basisvaluta",
      industry: "Sector",
      industry_optional: "(optioneel)",
      select_industry: "Selecteer uw sector",
      cancel: "Annuleren",
      create_account: "Account aanmaken",
      success_title: "Account succesvol aangemaakt",
      success_description: "Wilt u nu een bank verbinden of doet u dit liever later?",
      connect_bank_now: "Bank nu verbinden",
      connect_bank_later: "Dit later doen",
      bank_title: "Verbind uw bank",
      bank_description: "Verbind veilig via Open Banking om transacties automatisch te importeren.",
      bank_security_title: "Beveiliging op bankniveau",
      bank_security_description: "Uw inloggegevens worden nooit opgeslagen. Alleen-lezen verbindingen, EU-gereguleerd.",
      connect_bank_account: "Bankrekening verbinden",
      connecting: "Verbinden...",
      skip_for_now: "Nu overslaan",
      bank_connected_title: "Bank succesvol verbonden",
      bank_connected_description: "Uw bankrekening is nu verbonden en synchroniseert.",
      finish: "Voltooien"
    }
  },
  sv: {
    step_account: "Konto",
    step_bank: "Bank",
    step_success: "Framgång",
    account_title: "Skapa ditt första konto",
    account_description: "Låt oss konfigurera ditt företagskonto. Detta kommer att vara grunden för all din finansiella data.",
    company_name: "Företagsnamn",
    company_name_required: "Företagsnamn *",
    company_name_placeholder: "Ditt företagsnamn",
    country_currency: "Land & Valuta *",
    select_country: "Välj ditt land",
    base_currency: "Basvaluta",
    language: "Språk",
    language_preselected: "Förvald baserat på dina webbläsarinställningar",
    industry: "Bransch",
    industry_optional: "(valfritt)",
    select_industry: "Välj din bransch",
    industry_help: "Detta hjälper oss att ge bättre insikter och jämförelser",
    continue: "Fortsätt",
    need_help: "Behöver du hjälp?",
    contact_support: "Kontakta support",
    bank_title: "Anslut din bank",
    bank_description: "Anslut {{companyName}}s bankkonto via säker Open Banking för att automatiskt importera transaktioner.",
    bank_security_title: "Säkerhet på banknivå",
    bank_security_description: "Vi använder Yapilys Open Banking-plattform. Dina inloggningsuppgifter lagras aldrig och anslutningar är skrivskyddade. EU-reglerad och helt säker.",
    bank_security_bullet_credentials: "Dina inloggningsuppgifter lagras aldrig av MoneyLights",
    bank_security_bullet_readonly: "Bankanslutningar är skrivskyddade — vi kan aldrig flytta pengar",
    bank_security_bullet_regulated: "Powered by Yapily, EU-reglerad Open Banking",
    connect_bank_account: "Anslut bankkonto",
    connecting: "Ansluter...",
    supported_banks: "Banker som stöds i EU-länder",
    more_banks: "+300 fler",
    bank_connected_title: "Bank ansluten framgångsrikt",
    bank_connected_description: "Ditt bankkonto är nu anslutet. Vi startar den inledande synkroniseringen.",
    back: "Tillbaka",
    skip_for_now: "Hoppa över just nu",
    skip_help: "Du kan ansluta din bank senare i Inställningar",
    sync_limit_info: "Open Banking tillåter upp till 4 synkroniseringar per dag. MoneyLights schemalägger synkroniseringar automatiskt för att hålla din data uppdaterad utan att nå gränser. Du behöver inte göra något — MoneyLights hanterar synkroniseringar automatiskt.",
    success_title_with_bank: "Du är redo, {{companyName}}!",
    success_title_without_bank: "Konto skapat, {{companyName}}!",
    success_description_with_bank: "Ditt konto är skapat och din bank är ansluten. Vi synkroniserar dina transaktioner i bakgrunden.",
    success_description_without_bank: "Ditt konto är skapat. Du kan ansluta din bank när som helst i Inställningar för att börja importera transaktioner automatiskt.",
    success_bank_syncing: "Synkroniserar din bank",
    success_bank_syncing_description: "Dina transaktioner importeras i bakgrunden",
    success_bank_not_connected: "Bank ej ansluten",
    success_connect_later: "Du kan ansluta senare",
    next_steps: "Nästa steg",
    next_step_cashflow: "Se vart dina pengar tar vägen",
    next_step_cashflow_description: "Visualisera inkomster, utgifter och kassaflödestrender",
    next_step_categories: "Organisera transaktioner efter kategorier",
    next_step_categories_description: "Skapa anpassade kategorier för att bättre förstå dina utgifter",
    cta_view_money: "Open MoneyLights",
    completing: "Slutför...",
    success_help_tip: "Du kan fråga mig vad som helst om dina finanser — jag är här för att hjälpa dig tolka dina siffror",
    create_account_flow: {
      title: "Skapa nytt konto",
      description: "Lägg till ett nytt företag eller finansiellt sammanhang till MoneyLights.",
      company_name_required: "Företagsnamn *",
      company_name_placeholder: "Ditt företagsnamn",
      country_currency: "Land & Valuta *",
      select_country: "Välj ditt land",
      base_currency: "Basvaluta",
      industry: "Bransch",
      industry_optional: "(valfritt)",
      select_industry: "Välj din bransch",
      cancel: "Avbryt",
      create_account: "Skapa konto",
      success_title: "Konto skapat framgångsrikt",
      success_description: "Vill du ansluta en bank nu eller föredrar du att göra det senare?",
      connect_bank_now: "Anslut bank nu",
      connect_bank_later: "Gör detta senare",
      bank_title: "Anslut din bank",
      bank_description: "Anslut säkert via Open Banking för att automatiskt importera transaktioner.",
      bank_security_title: "Säkerhet på banknivå",
      bank_security_description: "Dina inloggningsuppgifter lagras aldrig. Skrivskyddade anslutningar, EU-reglerade.",
      connect_bank_account: "Anslut bankkonto",
      connecting: "Ansluter...",
      skip_for_now: "Hoppa över för nu",
      bank_connected_title: "Bank ansluten framgångsrikt",
      bank_connected_description: "Ditt bankkonto är nu anslutet och synkroniserar.",
      finish: "Slutför"
    }
  },
  da: {
    step_account: "Konto",
    step_bank: "Bank",
    step_success: "Succes",
    account_title: "Opret din første konto",
    account_description: "Lad os konfigurere din virksomhedskonto. Dette vil være grundlaget for alle dine finansielle data.",
    company_name: "Firmanavn",
    company_name_required: "Firmanavn *",
    company_name_placeholder: "Dit firmanavn",
    country_currency: "Land & Valuta *",
    select_country: "Vælg dit land",
    base_currency: "Basisvaluta",
    language: "Sprog",
    language_preselected: "Forudvalgt baseret på dine browserindstillinger",
    industry: "Branche",
    industry_optional: "(valgfrit)",
    select_industry: "Vælg din branche",
    industry_help: "Dette hjælper os med at give bedre indsigt og benchmarks",
    continue: "Fortsæt",
    need_help: "Brug for hjælp?",
    contact_support: "Kontakt support",
    bank_title: "Tilslut din bank",
    bank_description: "Tilslut {{companyName}}s bankkonto via sikker Open Banking for automatisk at importere transaktioner.",
    bank_security_title: "Sikkerhed på bankniveau",
    bank_security_description: "Vi bruger Yapilys Open Banking-platform. Dine legitimationsoplysninger gemmes aldrig, og forbindelser er skrivebeskyttede. EU-reguleret og fuldt sikker.",
    bank_security_bullet_credentials: "Dine loginoplysninger gemmes aldrig af MoneyLights",
    bank_security_bullet_readonly: "Bankforbindelser er skrivebeskyttede — vi kan aldrig flytte penge",
    bank_security_bullet_regulated: "Powered by Yapily, EU-reguleret Open Banking",
    connect_bank_account: "Tilslut bankkonto",
    connecting: "Tilslutter...",
    supported_banks: "Understøttede banker i EU-lande",
    more_banks: "+300 flere",
    bank_connected_title: "Bank tilsluttet succesfuldt",
    bank_connected_description: "Din bankkonto er nu tilsluttet. Vi starter den indledende synkronisering.",
    back: "Tilbage",
    skip_for_now: "Spring over nu",
    skip_help: "Du kan tilslutte din bank senere i Indstillinger",
    sync_limit_info: "Open Banking tillader op til 4 synkroniseringer om dagen. MoneyLights planlægger automatisk synkroniseringer for at holde dine data opdaterede uden at nå grænserne.",
    success_title_with_bank: "Du er klar, {{companyName}}!",
    success_title_without_bank: "Konto oprettet, {{companyName}}!",
    success_description_with_bank: "Din konto er oprettet, og din bank er tilsluttet. Vi synkroniserer dine transaktioner i baggrunden.",
    success_description_without_bank: "Din konto er oprettet. Du kan tilslutte din bank når som helst i Indstillinger for at begynde at importere transaktioner automatisk.",
    success_bank_syncing: "Synkroniserer din bank",
    success_bank_syncing_description: "Dine transaktioner importeres i baggrunden",
    success_bank_not_connected: "Bank ikke tilsluttet",
    success_connect_later: "Du kan tilslutte senere",
    next_steps: "Næste skridt",
    next_step_cashflow: "Se hvor dine penge går hen",
    next_step_cashflow_description: "Visualiser indtægter, udgifter og pengestrømstendenser",
    next_step_categories: "Organiser transaktioner efter kategorier",
    next_step_categories_description: "Opret tilpassede kategorier for bedre at forstå dine udgifter",
    cta_view_money: "Open MoneyLights",
    completing: "Færdiggør...",
    success_help_tip: "Du kan spørge mig om hvad som helst om dine finanser — jeg er her for at hjælpe dig med at fortolke dine tal",
    create_account_flow: {
      title: "Opret ny konto",
      description: "Tilføj en ny virksomhed eller finansiel kontekst til MoneyLights.",
      company_name_required: "Firmanavn *",
      company_name_placeholder: "Dit firmanavn",
      country_currency: "Land & Valuta *",
      select_country: "Vælg dit land",
      base_currency: "Basisvaluta",
      industry: "Branche",
      industry_optional: "(valgfrit)",
      select_industry: "Vælg din branche",
      cancel: "Annuller",
      create_account: "Opret konto",
      success_title: "Konto oprettet med succes",
      success_description: "Vil du tilslutte en bank nu, eller foretrækker du at gøre det senere?",
      connect_bank_now: "Tilslut bank nu",
      connect_bank_later: "Gør dette senere",
      bank_title: "Tilslut din bank",
      bank_description: "Tilslut sikkert via Open Banking for automatisk at importere transaktioner.",
      bank_security_title: "Sikkerhed på bankniveau",
      bank_security_description: "Dine loginoplysninger gemmes aldrig. Skrivebeskyttede forbindelser, EU-reguleret.",
      connect_bank_account: "Tilslut bankkonto",
      connecting: "Tilslutter...",
      skip_for_now: "Spring over nu",
      bank_connected_title: "Bank tilsluttet med succes",
      bank_connected_description: "Din bankkonto er nu tilsluttet og synkroniserer.",
      finish: "Afslut"
    }
  },
  fi: {
    step_account: "Tili",
    step_bank: "Pankki",
    step_success: "Onnistui",
    account_title: "Luo ensimmäinen tilisi",
    account_description: "Määritetään yrityksesi tili. Tämä on kaikkien taloustietojesi perusta.",
    company_name: "Yrityksen nimi",
    company_name_required: "Yrityksen nimi *",
    company_name_placeholder: "Yrityksesi nimi",
    country_currency: "Maa ja Valuutta *",
    select_country: "Valitse maasi",
    base_currency: "Perusvaluutta",
    language: "Kieli",
    language_preselected: "Esivalittu selaimen asetusten perusteella",
    industry: "Toimiala",
    industry_optional: "(valinnainen)",
    select_industry: "Valitse toimialasi",
    industry_help: "Tämä auttaa meitä tarjoamaan parempia oivalluksia ja vertailuarvoja",
    continue: "Jatka",
    need_help: "Tarvitsetko apua?",
    contact_support: "Ota yhteyttä tukeen",
    bank_title: "Yhdistä pankkisi",
    bank_description: "Yhdistä {{companyName}}n pankkitili turvallisen Open Bankingin kautta tapahtumien automaattiseksi tuomiseksi.",
    bank_security_title: "Pankkitason turvallisuus",
    bank_security_description: "Käytämme Yapilyn Open Banking -alustaa. Tunnuksiasi ei koskaan tallenneta ja yhteydet ovat vain luku -tilassa. EU:n sääntelemä ja täysin turvallinen.",
    bank_security_bullet_credentials: "Tunnuksiasi ei koskaan tallenneta MoneyLightsiin",
    bank_security_bullet_readonly: "Pankkiyhteydet ovat vain luku -tilassa — emme voi koskaan siirtää varoja",
    bank_security_bullet_regulated: "Powered by Yapily, EU:n sääntelemä Open Banking",
    connect_bank_account: "Yhdistä pankkitili",
    connecting: "Yhdistetään...",
    supported_banks: "Tuetut pankit EU-maissa",
    more_banks: "+300 lisää",
    bank_connected_title: "Pankki yhdistetty onnistuneesti",
    bank_connected_description: "Pankkitilisi on nyt yhdistetty. Aloitamme alkuperäisen synkronoinnin.",
    back: "Takaisin",
    skip_for_now: "Ohita toistaiseksi",
    skip_help: "Voit yhdistää pankkisi myöhemmin Asetuksissa",
    sync_limit_info: "Open Banking sallii jopa 4 synkronointia päivässä. MoneyLights ajoittaa synkronoinnit automaattisesti pitääkseen tietosi ajan tasalla ylittämättä rajoja.",
    success_title_with_bank: "Olet valmis, {{companyName}}!",
    success_title_without_bank: "Tili luotu, {{companyName}}!",
    success_description_with_bank: "Tilisi on luotu ja pankkisi on yhdistetty. Synkronoimme tapahtumasi taustalla.",
    success_description_without_bank: "Tilisi on luotu. Voit yhdistää pankkisi milloin tahansa Asetuksissa aloittaaksesi tapahtumien automaattisen tuonnin.",
    success_bank_syncing: "Synkronoidaan pankkiasi",
    success_bank_syncing_description: "Tapahtumasi tuodaan taustalla",
    success_bank_not_connected: "Pankkia ei yhdistetty",
    success_connect_later: "Voit yhdistää myöhemmin",
    next_steps: "Seuraavat vaiheet",
    next_step_cashflow: "Näe minne rahasi menevät",
    next_step_cashflow_description: "Visualisoi tulot, menot ja kassavirtatrendit",
    next_step_categories: "Järjestä tapahtumat kategorioittain",
    next_step_categories_description: "Luo mukautettuja kategorioita ymmärtääksesi menosi paremmin",
    cta_view_money: "Open MoneyLights",
    completing: "Viimeistellään...",
    success_help_tip: "Voit kysyä minulta mitä tahansa rahoistasi — olen täällä auttaakseni sinua tulkitsemaan lukujasi",
    create_account_flow: {
      title: "Luo uusi tili",
      description: "Lisää uusi yritys tai rahoituskonteksti MoneyLightsiin.",
      company_name_required: "Yrityksen nimi *",
      company_name_placeholder: "Yrityksesi nimi",
      country_currency: "Maa & Valuutta *",
      select_country: "Valitse maasi",
      base_currency: "Perusvaluutta",
      industry: "Toimiala",
      industry_optional: "(valinnainen)",
      select_industry: "Valitse toimialasi",
      cancel: "Peruuta",
      create_account: "Luo tili",
      success_title: "Tili luotu onnistuneesti",
      success_description: "Haluatko yhdistää pankin nyt vai haluatko tehdä sen myöhemmin?",
      connect_bank_now: "Yhdistä pankki nyt",
      connect_bank_later: "Tee tämä myöhemmin",
      bank_title: "Yhdistä pankkisi",
      bank_description: "Yhdistä turvallisesti Open Bankingin kautta tuodaksesi tapahtumat automaattisesti.",
      bank_security_title: "Pankkitason turvallisuus",
      bank_security_description: "Kirjautumistietojasi ei koskaan tallenneta. Vain luku -yhteydet, EU:n sääntelemiä.",
      connect_bank_account: "Yhdistä pankkitili",
      connecting: "Yhdistetään...",
      skip_for_now: "Ohita toistaiseksi",
      bank_connected_title: "Pankki yhdistetty onnistuneesti",
      bank_connected_description: "Pankkitilisi on nyt yhdistetty ja synkronoidaan.",
      finish: "Valmis"
    }
  }
};

export const industriesTranslations = {
  pt: {
    consulting: "Consultoria e Serviços Profissionais",
    construction: "Construção",
    ecommerce: "E-commerce e Retalho",
    education: "Educação e Formação",
    finance: "Finanças e Seguros",
    food: "Alimentação e Bebidas",
    healthcare: "Saúde",
    manufacturing: "Indústria",
    marketing: "Marketing e Publicidade",
    media: "Media e Entretenimento",
    real_estate: "Imobiliário",
    technology: "Tecnologia e Software",
    transportation: "Transporte e Logística",
    other: "Outro"
  },
  en: {
    consulting: "Consulting & Professional Services",
    construction: "Construction",
    ecommerce: "E-commerce & Retail",
    education: "Education & Training",
    finance: "Finance & Insurance",
    food: "Food & Beverage",
    healthcare: "Healthcare",
    manufacturing: "Manufacturing",
    marketing: "Marketing & Advertising",
    media: "Media & Entertainment",
    real_estate: "Real Estate",
    technology: "Technology & Software",
    transportation: "Transportation & Logistics",
    other: "Other"
  },
  es: {
    consulting: "Consultoría y Servicios Profesionales",
    construction: "Construcción",
    ecommerce: "E-commerce y Minorista",
    education: "Educación y Formación",
    finance: "Finanzas y Seguros",
    food: "Alimentación y Bebidas",
    healthcare: "Salud",
    manufacturing: "Manufactura",
    marketing: "Marketing y Publicidad",
    media: "Medios y Entretenimiento",
    real_estate: "Bienes Raíces",
    technology: "Tecnología y Software",
    transportation: "Transporte y Logística",
    other: "Otro"
  },
  et: {
    consulting: "Konsultatsioon ja Professionaalsed Teenused",
    construction: "Ehitus",
    ecommerce: "E-kaubandus ja Jaemüük",
    education: "Haridus ja Koolitus",
    finance: "Rahandus ja Kindlustus",
    food: "Toit ja Joogid",
    healthcare: "Tervishoid",
    manufacturing: "Tootmine",
    marketing: "Turundus ja Reklaam",
    media: "Meedia ja Meelelahutus",
    real_estate: "Kinnisvara",
    technology: "Tehnoloogia ja Tarkvara",
    transportation: "Transport ja Logistika",
    other: "Muu"
  },
  de: {
    consulting: "Beratung & Professionelle Dienstleistungen",
    construction: "Bauwesen",
    ecommerce: "E-Commerce & Einzelhandel",
    education: "Bildung & Ausbildung",
    finance: "Finanzen & Versicherung",
    food: "Lebensmittel & Getränke",
    healthcare: "Gesundheitswesen",
    manufacturing: "Fertigung",
    marketing: "Marketing & Werbung",
    media: "Medien & Unterhaltung",
    real_estate: "Immobilien",
    technology: "Technologie & Software",
    transportation: "Transport & Logistik",
    other: "Sonstiges"
  },
  fr: {
    consulting: "Conseil & Services Professionnels",
    construction: "Construction",
    ecommerce: "E-commerce & Commerce de Détail",
    education: "Éducation & Formation",
    finance: "Finance & Assurance",
    food: "Alimentation & Boissons",
    healthcare: "Santé",
    manufacturing: "Fabrication",
    marketing: "Marketing & Publicité",
    media: "Médias & Divertissement",
    real_estate: "Immobilier",
    technology: "Technologie & Logiciel",
    transportation: "Transport & Logistique",
    other: "Autre"
  },
  it: {
    consulting: "Consulenza e Servizi Professionali",
    construction: "Costruzione",
    ecommerce: "E-commerce e Vendita al Dettaglio",
    education: "Istruzione e Formazione",
    finance: "Finanza e Assicurazioni",
    food: "Cibo e Bevande",
    healthcare: "Sanità",
    manufacturing: "Manifattura",
    marketing: "Marketing e Pubblicità",
    media: "Media e Intrattenimento",
    real_estate: "Immobiliare",
    technology: "Tecnologia e Software",
    transportation: "Trasporti e Logistica",
    other: "Altro"
  },
  nl: {
    consulting: "Consulting & Professionele Diensten",
    construction: "Bouw",
    ecommerce: "E-commerce & Detailhandel",
    education: "Onderwijs & Training",
    finance: "Financiën & Verzekeringen",
    food: "Voedsel & Dranken",
    healthcare: "Gezondheidszorg",
    manufacturing: "Productie",
    marketing: "Marketing & Reclame",
    media: "Media & Entertainment",
    real_estate: "Vastgoed",
    technology: "Technologie & Software",
    transportation: "Transport & Logistiek",
    other: "Overig"
  },
  sv: {
    consulting: "Konsultverksamhet & Professionella Tjänster",
    construction: "Byggverksamhet",
    ecommerce: "E-handel & Detaljhandel",
    education: "Utbildning & Träning",
    finance: "Finans & Försäkring",
    food: "Mat & Dryck",
    healthcare: "Hälsovård",
    manufacturing: "Tillverkning",
    marketing: "Marknadsföring & Reklam",
    media: "Media & Underhållning",
    real_estate: "Fastigheter",
    technology: "Teknologi & Mjukvara",
    transportation: "Transport & Logistik",
    other: "Annat"
  },
  da: {
    consulting: "Rådgivning & Professionelle Tjenester",
    construction: "Byggeri",
    ecommerce: "E-handel & Detailhandel",
    education: "Uddannelse & Træning",
    finance: "Finans & Forsikring",
    food: "Mad & Drikkevarer",
    healthcare: "Sundhedsvæsen",
    manufacturing: "Fremstilling",
    marketing: "Marketing & Reklame",
    media: "Medier & Underholdning",
    real_estate: "Ejendomme",
    technology: "Teknologi & Software",
    transportation: "Transport & Logistik",
    other: "Andet"
  },
  fi: {
    consulting: "Konsultointi & Ammattimaiset Palvelut",
    construction: "Rakentaminen",
    ecommerce: "Verkkokauppa & Vähittäiskauppa",
    education: "Koulutus",
    finance: "Rahoitus & Vakuutus",
    food: "Ruoka & Juomat",
    healthcare: "Terveydenhuolto",
    manufacturing: "Valmistus",
    marketing: "Markkinointi & Mainonta",
    media: "Media & Viihde",
    real_estate: "Kiinteistöt",
    technology: "Teknologia & Ohjelmistot",
    transportation: "Kuljetus & Logistiikka",
    other: "Muu"
  }
};

export const bankSyncTranslations = {
  pt: {
    title: "Estado da Sincronização Bancária",
    auto_updates: "Atualizações automáticas até {{count}} vezes por dia",
    status_up_to_date: "Dados atualizados",
    status_stale: "Dados desatualizados",
    status_failed: "Falha na sincronização",
    last_sync: "Última sincronização",
    last_sync_label: "Última sincronização",
    never: "Nunca",
    next_sync: "Próxima sincronização disponível",
    syncs_used_today: "Sincronizações usadas hoje",
    unknown: "Desconhecido",
    now: "Agora",
    minutes_ago: "há {{minutes}}m",
    hours_ago: "há {{hours}}h",
    last_bank_sync: "Última sincronização bancária",
    next_sync_in: "Próxima sincronização em",
    refresh: "Atualizar",
    sync_failed_see_details: "Sincronização falhou. Ver detalhes",
    daily_limit_reached: "Limite diário de sincronizações atingido ({{used}}/{{max}}). Próxima sincronização disponível em {{time}}."
  },
  en: {
    title: "Bank Sync Status",
    auto_updates: "Automatic updates happen up to {{count}} times per day",
    status_up_to_date: "Data up to date",
    status_stale: "Stale data",
    status_failed: "Sync failed",
    last_sync: "Last successful sync",
    last_sync_label: "Last sync",
    never: "Never",
    next_sync: "Next available sync",
    syncs_used_today: "Syncs used today",
    unknown: "Unknown",
    now: "Now",
    minutes_ago: "{{minutes}}m ago",
    hours_ago: "{{hours}}h ago",
    last_bank_sync: "Last bank sync",
    next_sync_in: "Next sync in",
    refresh: "Refresh",
    sync_failed_see_details: "Sync failed. See details",
    daily_limit_reached: "Daily sync limit reached ({{used}}/{{max}}). Next sync available in {{time}}."
  },
  es: {
    title: "Estado de Sincronización Bancaria",
    auto_updates: "Actualizaciones automáticas hasta {{count}} veces al día",
    status_up_to_date: "Datos actualizados",
    status_stale: "Datos desactualizados",
    status_failed: "Sincronización fallida",
    last_sync: "Última sincronización exitosa",
    last_sync_label: "Última sincronización",
    never: "Nunca",
    next_sync: "Próxima sincronización disponible",
    syncs_used_today: "Sincronizaciones usadas hoy",
    unknown: "Desconocido",
    now: "Ahora",
    minutes_ago: "hace {{minutes}}m",
    hours_ago: "hace {{hours}}h",
    last_bank_sync: "Última sincronización bancaria",
    next_sync_in: "Próxima sincronización en",
    refresh: "Actualizar",
    sync_failed_see_details: "Sincronización fallida. Ver detalles",
    daily_limit_reached: "Límite diario de sincronizaciones alcanzado ({{used}}/{{max}}). Próxima sincronización disponible en {{time}}."
  },
  et: {
    title: "Panga sünkroonimise olek",
    auto_updates: "Automaatsed värskendused kuni {{count}} korda päevas",
    status_up_to_date: "Andmed ajakohased",
    status_stale: "Aegunud andmed",
    status_failed: "Sünkroonimine nurjus",
    last_sync: "Viimane edukas sünkroonimine",
    last_sync_label: "Viimane sünkr.",
    never: "Mitte kunagi",
    next_sync: "Järgmine saadaolev sünkroonimine",
    syncs_used_today: "Täna kasutatud sünkroonimisi",
    unknown: "Teadmata",
    now: "Nüüd",
    minutes_ago: "{{minutes}}m tagasi",
    hours_ago: "{{hours}}h tagasi",
    last_bank_sync: "Viimane panga sünkroonimine",
    next_sync_in: "Järgmine sünkroonimine",
    refresh: "Värskenda",
    sync_failed_see_details: "Sünkroonimine nurjus. Vaata üksikasju",
    daily_limit_reached: "Päevane sünkroonimise limiit saavutatud ({{used}}/{{max}}). Järgmine sünkroonimine saadaval {{time}} pärast."
  },
  de: {
    title: "Bank-Synchronisationsstatus",
    auto_updates: "Automatische Updates bis zu {{count}} Mal pro Tag",
    status_up_to_date: "Daten aktuell",
    status_stale: "Veraltete Daten",
    status_failed: "Synchronisation fehlgeschlagen",
    last_sync: "Letzte erfolgreiche Synchronisation",
    last_sync_label: "Letzte Synchronisation",
    never: "Nie",
    next_sync: "Nächste verfügbare Synchronisation",
    syncs_used_today: "Heute verwendete Synchronisationen",
    unknown: "Unbekannt",
    now: "Jetzt",
    minutes_ago: "vor {{minutes}}m",
    hours_ago: "vor {{hours}}h",
    last_bank_sync: "Letzte Bank-Synchronisation",
    next_sync_in: "Nächste Synchronisation in",
    refresh: "Aktualisieren",
    sync_failed_see_details: "Synchronisation fehlgeschlagen. Details anzeigen",
    daily_limit_reached: "Tägliches Synchronisationslimit erreicht ({{used}}/{{max}}). Nächste Synchronisation verfügbar in {{time}}."
  },
  fr: {
    title: "État de synchronisation bancaire",
    auto_updates: "Mises à jour automatiques jusqu'à {{count}} fois par jour",
    status_up_to_date: "Données à jour",
    status_stale: "Données obsolètes",
    status_failed: "Échec de la synchronisation",
    last_sync: "Dernière synchronisation réussie",
    last_sync_label: "Dernière synchro.",
    never: "Jamais",
    next_sync: "Prochaine synchronisation disponible",
    syncs_used_today: "Synchronisations utilisées aujourd'hui",
    unknown: "Inconnu",
    now: "Maintenant",
    minutes_ago: "il y a {{minutes}}m",
    hours_ago: "il y a {{hours}}h",
    last_bank_sync: "Dernière synchronisation bancaire",
    next_sync_in: "Prochaine synchronisation dans",
    refresh: "Actualiser",
    sync_failed_see_details: "Échec de la synchronisation. Voir les détails",
    daily_limit_reached: "Limite quotidienne de synchronisation atteinte ({{used}}/{{max}}). Prochaine synchronisation disponible dans {{time}}."
  },
  it: {
    title: "Stato sincronizzazione bancaria",
    auto_updates: "Aggiornamenti automatici fino a {{count}} volte al giorno",
    status_up_to_date: "Dati aggiornati",
    status_stale: "Dati obsoleti",
    status_failed: "Sincronizzazione fallita",
    last_sync: "Ultima sincronizzazione riuscita",
    last_sync_label: "Ultima sincronizzazione",
    never: "Mai",
    next_sync: "Prossima sincronizzazione disponibile",
    syncs_used_today: "Sincronizzazioni utilizzate oggi",
    unknown: "Sconosciuto",
    now: "Ora",
    minutes_ago: "{{minutes}}m fa",
    hours_ago: "{{hours}}h fa",
    last_bank_sync: "Ultima sincronizzazione bancaria",
    next_sync_in: "Prossima sincronizzazione tra",
    refresh: "Aggiorna",
    sync_failed_see_details: "Sincronizzazione fallita. Vedi dettagli",
    daily_limit_reached: "Limite giornaliero di sincronizzazione raggiunto ({{used}}/{{max}}). Prossima sincronizzazione disponibile tra {{time}}."
  },
  nl: {
    title: "Banksynchronisatiestatus",
    auto_updates: "Automatische updates tot {{count}} keer per dag",
    status_up_to_date: "Bijgewerkt",
    status_stale: "Verouderde gegevens",
    status_failed: "Synchronisatie mislukt",
    last_sync: "Laatste succesvolle synchronisatie",
    last_sync_label: "Laatste synchronisatie",
    never: "Nooit",
    next_sync: "Volgende beschikbare synchronisatie",
    syncs_used_today: "Synchronisaties gebruikt vandaag",
    unknown: "Onbekend",
    now: "Nu",
    minutes_ago: "{{minutes}}m geleden",
    hours_ago: "{{hours}}u geleden",
    last_bank_sync: "Laatste banksynchronisatie",
    next_sync_in: "Volgende synchronisatie over",
    refresh: "Vernieuwen",
    sync_failed_see_details: "Synchronisatie mislukt. Zie details",
    daily_limit_reached: "Dagelijkse synchronisatielimiet bereikt ({{used}}/{{max}}). Volgende synchronisatie beschikbaar over {{time}}."
  },
  sv: {
    title: "Banksynkroniseringsstatus",
    auto_updates: "Automatiska uppdateringar upp till {{count}} gånger per dag",
    status_up_to_date: "Uppdaterad",
    status_stale: "Föråldrad data",
    status_failed: "Synkronisering misslyckades",
    last_sync: "Senaste lyckade synkronisering",
    last_sync_label: "Senaste synk.",
    never: "Aldrig",
    next_sync: "Nästa tillgängliga synkronisering",
    syncs_used_today: "Synkroniseringar använda idag",
    unknown: "Okänd",
    now: "Nu",
    minutes_ago: "{{minutes}}m sedan",
    hours_ago: "{{hours}}h sedan",
    last_bank_sync: "Senaste banksynkronisering",
    next_sync_in: "Nästa synkronisering om",
    refresh: "Uppdatera",
    sync_failed_see_details: "Synkronisering misslyckades. Se detaljer",
    daily_limit_reached: "Daglig synkroniseringsgräns nådd ({{used}}/{{max}}). Nästa synkronisering tillgänglig om {{time}}."
  },
  da: {
    title: "Banksynkroniseringsstatus",
    auto_updates: "Automatiske opdateringer op til {{count}} gange om dagen",
    status_up_to_date: "Opdateret",
    status_stale: "Forældede data",
    status_failed: "Synkronisering mislykkedes",
    last_sync: "Seneste vellykkede synkronisering",
    last_sync_label: "Seneste synkr.",
    never: "Aldrig",
    next_sync: "Næste tilgængelige synkronisering",
    syncs_used_today: "Synkroniseringer brugt i dag",
    unknown: "Ukendt",
    now: "Nu",
    minutes_ago: "{{minutes}}m siden",
    hours_ago: "{{hours}}t siden",
    last_bank_sync: "Seneste banksynkronisering",
    next_sync_in: "Næste synkronisering om",
    refresh: "Opdater",
    sync_failed_see_details: "Synkronisering mislykkedes. Se detaljer",
    daily_limit_reached: "Daglig synkroniseringsgrænse nået ({{used}}/{{max}}). Næste synkronisering tilgængelig om {{time}}."
  },
  fi: {
    title: "Pankkisynkronoinnin tila",
    auto_updates: "Automaattiset päivitykset jopa {{count}} kertaa päivässä",
    status_up_to_date: "Ajan tasalla",
    status_stale: "Vanhentuneet tiedot",
    status_failed: "Synkronointi epäonnistui",
    last_sync: "Viimeisin onnistunut synkronointi",
    last_sync_label: "Viimeisin synkr.",
    never: "Ei koskaan",
    next_sync: "Seuraava saatavilla oleva synkronointi",
    syncs_used_today: "Tänään käytetyt synkronoinnit",
    unknown: "Tuntematon",
    now: "Nyt",
    minutes_ago: "{{minutes}}m sitten",
    hours_ago: "{{hours}}h sitten",
    last_bank_sync: "Viimeisin pankkisynkronointi",
    next_sync_in: "Seuraava synkronointi",
    refresh: "Päivitä",
    sync_failed_see_details: "Synkronointi epäonnistui. Katso tiedot",
    daily_limit_reached: "Päivittäinen synkronointiraja saavutettu ({{used}}/{{max}}). Seuraava synkronointi saatavilla {{time}} kuluttua."
  }
};
